import { Helmet } from "react-helmet-async";

type SeoHeadProps = {
  title: string;
  description?: string;
  canonical?: string;
  images?: string[];
  langAlternates?: { hrefLang: string; href: string }[];
  structuredData?: Record<string, any>[];
  noindex?: boolean;
  siteName?: string;
};

export default function SeoHead({
  title,
  description,
  canonical,
  images = [],
  langAlternates = [],
  structuredData = [],
  noindex = false,
  siteName = "VilleSalento",
}: SeoHeadProps) {
  const ogImage = images[0];

  return (
    <>
      <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        {canonical && <link rel="canonical" href={canonical} />}

        {noindex && <meta name="robots" content="noindex,nofollow" />}

        {/* Open Graph */}
        <meta property="og:site_name" content={siteName} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        {description && <meta property="og:description" content={description} />}
        {canonical && <meta property="og:url" content={canonical} />}
        {ogImage && <meta property="og:image" content={ogImage} />}

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        {description && <meta name="twitter:description" content={description} />}
        {ogImage && <meta name="twitter:image" content={ogImage} />}

        {/* hreflang */}
        {langAlternates.map((a) => (
          <link key={a.hrefLang} rel="alternate" hrefLang={a.hrefLang} href={a.href} />
        ))}
      </Helmet>

      {/* JSON-LD (accetta più blocchi) */}
      {structuredData.map((block, i) => (
        <Helmet key={i}>
          <script type="application/ld+json">{JSON.stringify(block)}</script>
        </Helmet>
      ))}
    </>
  );
}
